import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Hash, Tv, Smartphone, ArrowLeft } from "lucide-react";

const L = {
  es: { tag: "Serie Secreta", title: "Serie Secreta", sub: "Con tus cartas UNO reales",
        blurb: "Cada jugador recibe una serie secreta de 5 números. Saca cartas UNO y marca cada número que encuentres. ¡El primero en completar su serie gana!",
        host: "Crear mesa (TV)", hostSub: "TV / pantalla compartida", join: "Unirse como jugador", joinSub: "Tu teléfono", back: "Menú de juegos" },
  en: { tag: "Secret Series", title: "Secret Series", sub: "With your real UNO cards",
        blurb: "Each player gets a secret 5-number series. Draw UNO cards and mark every number you find. First to complete their series wins!",
        host: "Create table (TV)", hostSub: "TV / shared screen", join: "Join as player", joinSub: "Your phone", back: "Game menu" },
};

export default function UnoLanding() {
  const nav = useNavigate();
  const [lang, setLang] = useState("es");
  const t = L[lang];

  return (
    <div className="relative min-h-screen overflow-hidden grain" style={{ background: "radial-gradient(circle at 30% 20%, #10243a, #0b1220 70%)" }}>
      <div className="absolute top-6 right-6 z-20 flex gap-2">
        {["es", "en"].map((l) => (
          <button key={l} data-testid={`serie-lang-${l}`} onClick={() => setLang(l)}
            className={`px-4 py-2 rounded-full text-sm font-semibold btn-tactile border ${lang === l ? "bg-[#2e86ab] text-white border-[#2e86ab]" : "glass text-parchment border-white/20"}`}>
            {l === "es" ? "🇪🇸 ES" : "🇺🇸 EN"}
          </button>
        ))}
      </div>
      <button data-testid="serie-back-btn" onClick={() => nav("/")} className="absolute top-6 left-6 z-20 inline-flex items-center gap-2 text-sand/70 hover:text-white text-sm"><ArrowLeft className="w-4 h-4" /> {t.back}</button>

      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6 py-16 max-w-3xl mx-auto text-center">
        <div className="flex items-center gap-3 mb-6 animate-fade-in">
          <div className="flex gap-1">
            {["#e4572e", "#f3a712", "#17a398", "#2e86ab"].map((c) => <span key={c} className="w-3 h-8 rounded-sm" style={{ background: c }} />)}
          </div>
          <span className="uppercase tracking-[0.35em] text-xs font-semibold text-sand">{t.tag}</span>
        </div>
        <h1 className="font-display font-800 text-5xl sm:text-6xl leading-none text-white animate-fade-up flex items-center gap-3">
          <Hash className="w-12 h-12 text-[#f3a712]" /> {t.title}
        </h1>
        <p className="mt-4 font-serif italic text-xl text-[#5fb0d4] animate-fade-up">{t.sub}</p>
        <p className="mt-6 max-w-xl text-sand/80 text-base sm:text-lg animate-fade-up">{t.blurb}</p>

        <div className="mt-12 grid sm:grid-cols-2 gap-5 w-full max-w-2xl">
          <button data-testid="serie-host-btn" onClick={() => nav("/serie/host")}
            className="group glass btn-tactile rounded-2xl p-7 text-left border-2 border-[#2e86ab]/50 hover:border-[#f3a712]">
            <Tv className="w-9 h-9 text-[#f3a712] mb-3 transition-transform group-hover:scale-110" />
            <div className="font-serif text-2xl text-white">{t.host}</div>
            <div className="text-sand/60 text-sm mt-1">{t.hostSub}</div>
          </button>
          <button data-testid="serie-join-btn" onClick={() => nav("/serie/play")}
            className="group glass btn-tactile rounded-2xl p-7 text-left border-2 border-[#2e86ab]/50 hover:border-[#f3a712]">
            <Smartphone className="w-9 h-9 text-[#f3a712] mb-3 transition-transform group-hover:scale-110" />
            <div className="font-serif text-2xl text-white">{t.join}</div>
            <div className="text-sand/60 text-sm mt-1">{t.joinSub}</div>
          </button>
        </div>
      </div>
    </div>
  );
}
